import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "mb-4 transition-y" }
const _hoisted_3 = { class: "position-relative mb-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_6 = { class: "fs-20 mb-0" }
const _hoisted_7 = { class: "fs-16 fw-normal" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_9 = { class: "col-lg-12" }
const _hoisted_10 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_11 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-lg-4 col-sm-6",
        key: product.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_RouterLink, {
              to: product.link
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: product.image,
                  class: "rounded-3",
                  alt: "product"
                }, null, 8, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createVNode(_component_RouterLink, {
              to: "/ecommerce/cart",
              class: "bg-body-bg bg-for-dark-mode pt-2 ps-2 position-absolute bottom-0 end-0 rounded-3 rounded-bottom-0 rounded-end-0"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "material-symbols-outlined wh-60 lh-60 bg-primary hover-bg d-inline-block text-white text-center rounded-3 fs-24" }, " shopping_cart ", -1)
              ])),
              _: 1
            })
          ]),
          _createVNode(_component_RouterLink, {
            to: product.link,
            class: "text-secondary text-decoration-none fs-16 hover d-block mb-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(product.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, [
              _createTextVNode(" $" + _toDisplayString(product.price) + " ", 1),
              _createElementVNode("del", _hoisted_7, "$" + _toDisplayString(product.oldPrice), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                return _createElementVNode("i", {
                  key: star,
                  class: _normalizeClass(["fs-16 text-warning", _ctx.starClass(star, product.ratings)])
                }, null, 2)
              }), 64))
            ])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Pagination, {
            items: "09",
            total: "30"
          })
        ])
      ])
    ])
  ]))
}